import React, { useState } from 'react';
import { TextField, Button, Alert, Stack } from '@mui/material';

export default function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!name || !email) {
      setError('Name and email are required');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch('/api/contact-leads/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg =
          data.detail ||
          Object.values(data)
            .flat()
            .join(' ');
        throw new Error(msg || 'Failed to submit');
      }
      setSuccess('Thanks for reaching out! We will get back to you soon.');
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Stack spacing={2}>
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          InputProps={{ sx: { backgroundColor: '#fff', color: '#182D46' } }}
          InputLabelProps={{
            sx: {
              color: '#182D46',
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -2px) scale(0.75)',
              },
            },
          }}
        />
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          InputProps={{ sx: { backgroundColor: '#fff', color: '#182D46' } }}
          InputLabelProps={{
            sx: {
              color: '#182D46',
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -2px) scale(0.75)',
              },
            },
          }}
        />
        <TextField
          label="Message"
          multiline
          minRows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          InputProps={{ sx: { backgroundColor: '#fff', color: '#182D46' } }}
          InputLabelProps={{
            sx: {
              color: '#182D46',
              '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, -2px) scale(0.75)',
              },
            },
          }}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: '#FF8210',
            color: '#0A101E',
            '&:hover': {
              backgroundColor: '#e67300',
            },
          }}
        >
          Submit
        </Button>
      </Stack>
    </form>
  );
}
